export default [{
  path: '/template-email',
  component: {
    name: 'templateemail',
    template: '<router-view />',
    meta: {
      resource: 'templateemail',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'template-email',
    component: () => import('@/app-modulo/comuns/templates-gerais/shared/components/templates-email/TemplateEmailsView.vue'),
    meta: {
      resource: 'templateemail',
      action: 'read',
      navActiveLink: 'template-e-mail',
      pageTitle: 'Template de E-mail',
      breadcrumb: [
        {
          text: 'Templates',
          to: { name: 'template-email' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-template-email',
    component: () => import('@/app-modulo/comuns/templates-gerais/shared/components/templates-email/shared/CadastroTemplate/CadastroTemplateEmail.vue'),
    meta: {
      resource: 'templateemail',
      action: 'create',
      navActiveLink: 'templateemail',
      pageTitle: 'Template de E-mail',
      breadcrumb: [
        {
          text: 'Templates',
          to: { name: 'template-email' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-template-email' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-template-email',
    component: () => import('@/app-modulo/comuns/templates-gerais/shared/components/templates-email/shared/CadastroTemplate/CadastroTemplateEmail.vue'),
    meta: {
      resource: 'templateemail',
      action: 'update',
      navActiveLink: 'templateemail',
      pageTitle: 'Template de E-mail',
      breadcrumb: [
        {
          text: 'Templates',
          to: { name: 'template-email' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-template-email' },
          active: true,
        },
      ],
    },
  },
  ],
}]
